import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getLectureList(args) {
        const response = await service.get(`${getApiBaseUrl()}lecture`, args);
        return response;
    },

    async getLecture(id) {
        const response = await service.get(`${getApiBaseUrl()}lecture/${id}`);
        return response;
    },

    async addLecture(lecture) {
        const response = await service.post(
            `${getApiBaseUrl()}lecture`,
            lecture
        );
        return response;
    },

    async updateLecture(lecture) {
        const response = await service.patch(
            `${getApiBaseUrl()}lecture`,
            lecture
        );
        return response;
    },

    async deleteLecture(lecture_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}lecture/${lecture_id}`
        );
        return response;
    },

    async deleteApplyLecture(applyLecture_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}lecture/apply/${applyLecture_id}`
        );
        return response;
    },

    async applyLecture(lecture) {
        const response = await service.post(
            `${getApiBaseUrl()}lecture/apply`,
            lecture
        );
        return response;
    },

    async getApplyLectureList(args) {
        const response = await service.get(
            `${getApiBaseUrl()}lecture/apply`,
            args
        );
        return response;
    },


    async verifyPin(args) {
        const response = await service.post(
            `${getApiBaseUrl()}lecture/verify`,
            args
        );
        return response;
    },
};
